import axios from 'axios';

const baseURL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5001/api';

const api = axios.create({
  baseURL: baseURL,
  timeout: 300000, // 5分钟超时，支持大文件上传
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 优先检查后台管理平台的token
    const adminToken = localStorage.getItem('token');
    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    } else {
      // 否则使用学校平台的token
      const schoolToken = localStorage.getItem('school_token');
      if (schoolToken) {
        config.headers.Authorization = `Bearer ${schoolToken}`;
      }
    }
    console.log('Request Headers:', config.headers); // 调试日志
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default api;